import { makeAutoObservable } from 'mobx';
import { ISaveable } from '../../../../../stores/types';
import { ICredentialsStore } from '../integration-store';

export interface IMintsoftCredentials {
    api_key: string
}

class MintsoftCredentialsStore implements ISaveable, ICredentialsStore {
    private _changes: IMintsoftCredentials = {} as IMintsoftCredentials;

    constructor() {
        makeAutoObservable(this);
    }

    public get api_key() { return this._changes.api_key; }

    public set api_key(v: string) { this._changes.api_key = v; }

    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }


    /********* ISaveable implementation *************/
    public hasChanges(): boolean {
        return !!Object.keys(this._changes).length;
    }

    public discardChanges(): void {
        this._changes = {} as IMintsoftCredentials;
    }

    public getUpdatedModel(): IMintsoftCredentials { throw new Error('Not implemented.'); }
    public isSaving(): boolean { throw new Error('Not implemented.'); }
    public commitChanges() { throw new Error('Not implemented.'); }
    public async save() { throw new Error('Not implemented.'); }
}

export default MintsoftCredentialsStore;
